import { factorySetStateAction } from '../factory'

// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
}

export const menuSetState = factorySetStateAction(actions.SET_STATE)

export default actions
